import { combineReducers } from "redux";
import initialReducer from "./states/reducer";
import userReducer from "./screens/users/states/reducer";
import propsoalReducer from './screens/loans/states/reducer';
import tripsReducer from "./screens/trips/states/reducer";
import userAccessReducer from "./states/userAccessReducer";
import { reloadDetailsPage } from "./states/actions";

const rootReducer = combineReducers({
  userAccessReducer,
  initialReducer,
  userReducer,
  propsoalReducer,
  tripsReducer,
  reloadDetailsPage
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
